import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

type Fill = 'paper' | 'ink' | 'lost' | 'found' | 'solved' | 'urgent';

interface HeroMetricProps {
  value: ReactNode;
  label: string;
  fill?: Fill;
  className?: string;
}

const FILL_CLASS: Record<Fill, string> = {
  paper: 'fill-paper',
  ink: 'fill-ink',
  lost: 'fill-lost',
  found: 'fill-found',
  solved: 'fill-solved',
  urgent: 'fill-urgent',
};

export const HeroMetric: FC<HeroMetricProps> = ({
  value,
  label,
  fill = 'paper',
  className,
}) => (
  <div
    className={cn(
      'nb flex min-h-[110px] flex-col justify-between p-3',
      FILL_CLASS[fill],
      className,
    )}
    style={fill === 'ink' ? { color: 'var(--nb-paper)' } : undefined}
  >
    <div className="font-display text-[clamp(28px,8vw,36px)] leading-none">{value}</div>
    <div
      className="text-[10px] font-bold uppercase tracking-[0.08em]"
      style={{ fontFamily: '"JetBrains Mono", monospace' }}
    >
      {label}
    </div>
  </div>
);
